import { createFileRoute } from '@tanstack/react-router';
import * as v from 'valibot';
import { SuccessStep } from './-components/project-new-steps/success-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/projects/new/success')({
	component: SuccessStep,
	validateSearch: v.object({
		startDate: v.optional(v.string()),
		projectId: v.optional(v.string()),
		fundingType: v.optional(v.picklist(['myPortal', 'worldcoo', 'both'])),
	}),
});
